import { render } from "./FreeText.vue?vue&type=template&id=7017c123"
import script from "./FreeText.vue?vue&type=script&lang=js"
export * from "./FreeText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__